<template>
  <div>
    <v-card tile>
      <v-card-text class="py-0">
        <v-container class="px-0">
          <h1 class="mb-5">Set Giro Sudah Cair</h1>
          <v-row>
            <v-col cols="12" sm="6" md="3" class="fit-content">
              <v-text-field
                label="Tanggal"
                hide-details
                outlined
                dense
                type="date"
                v-model="formDataCair.tanggal"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="fit-content">
              <v-text-field
                label="Nomor Giro"
                hide-details
                outlined
                dense
                type="text"
                v-model="formDataCair.nomor_giro"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2" class="fit-content">
              <v-btn
                color="primary"
                @click="saveData('cair')"
                :loading="state.loadingSaveData === 'cair'"
              >
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card tile class="mt-10">
      <v-card-text class="py-0">
        <v-container class="px-0">
          <h1 class="mb-5">Set Giro Belum Cair</h1>
          <v-row>
            <v-col cols="12" sm="6" md="3" class="fit-content">
              <v-text-field
                label="Nomor Giro"
                hide-details
                outlined
                dense
                type="text"
                v-model="formDataBelum.nomor_giro"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2" class="fit-content">
              <v-btn
                color="error"
                @click="saveData('belum')"
                :loading="state.loadingSaveData === 'belum'"
              >
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "InputGiroSudahCair",
  data() {
    return {
      formDataCair: {
        tanggal: "",
        nomor_giro: ""
      },
      formDataBelum: {
        nomor_giro: ""
      },
      state: {
        loadingSaveData: ""
      }
    };
  },
  methods: {
    async saveData(status) {
      this.state.loadingSaveData = status;

      if (status === "cair" && !this.formDataCair.tanggal) {
        alert("Tanggal harus diisi");
        this.state.loadingSaveData = "";
        return;
      }

      const formData =
        status === "cair" ? this.formDataCair : this.formDataBelum;

      await axios
        .put(`giro/update-status?status=${status}`, formData)
        .then(res => {
          this.state.loadingSaveData = "";
          this.formatForm();

          alert(res.data.message);
        })
        .catch(err => {
          this.state.loadingSaveData = "";

          alert(err.response.data.message);
        });
    },
    formatForm() {
      this.formDataCair = {
        tanggal: "",
        nomor_giro: ""
      };

      this.formDataBelum = {
        nomor_giro: ""
      };
    }
  }
};
</script>
